// components/PromptExample.tsx
"use client";
import { Flex, Text, Box, Show } from "@chakra-ui/react";
import ellie from "@public/ellie.png"
import { Image } from "@chakra-ui/react";
import Avatar_Image from "@public/Avatar-Image.webp";

export const PromptExample = () => {
  return (
    <Flex
      px={{ base: "20px", sm: "35px", md: "40px", lg: "60px", xl: "60px", "2xl": "12%" }}
      h="400px"
      justify="center"
      mt={{ base: "80px", md: "140px", lg: "160px" }}
    >
      {/* Desktop, >= 768px */}
      <Show above="md">
        <Flex  w={{base:"100%", md:"630px"}}  justify="center" align="center">
         
          <Image src={ellie.src}  />
        </Flex>
      </Show>
      <Flex direction="column" ml={{ lg: "50px" }}>
        <Text as={"h2"} fontSize={{ base: "26", lg: "40px" }} fontWeight="semibold">
          Create AI Images on Demand
        </Text>
        <Flex align="center">
          <Image h={{ base: "50px", md: "" }} w={{ base: "50px", md: "" }} src={Avatar_Image.src} />
          <Flex>
            <StyledText />
          </Flex>
        </Flex>
        {/* Desktop, >= 768px */}
        <Show above="md">
          <HighlightedWordsBoxes />
        </Show>
        {/* Mobile, < 768px */}
        <Show below="md-1">
          <Flex ml={{base:"40px", md:"10px"}} mt="15px" align="center">
           
            <Image src={ellie.src}  />
          </Flex>
        </Show>
      </Flex>
    </Flex>
  );
};

const StyledText = () => {
  return (
    <Box
      mt={{ base: "15px" }}
      ml="20px"
      w={{ base: "220px", lg: "100%" }}
      maxW="500px"
      fontSize={{ base: "14px", lg: "24px" }}
      fontWeight="semibold"
    >
      <Text>
        {' "Show me '}
        <Text as="span" color="#712EFF">
          Ellie
        </Text>
        {" in a "}
        <Text as="span" color="#FB00C0">
          Space Suit
        </Text>
        {" posing on "}
        <Text as="span" color="#FF7D4E">
          Mars 
        </Text>
        {'"'}
      </Text>
    </Box>
  );
};

const HighlightedWordsBoxes = () => {
  const highlights = [
    { word: "Ellie", color: "#712EFF" },
    { word: "Space Suit", color: "#FB00C0" },
    { word: "Mars", color: "#FF7D4E" },
  ];

  return (
    <Flex mt="25px">
      {highlights.map((highlight, index) => (
        <Flex
          direction="column"
          key={index}
          textAlign="center"
          mb="20px"
          ml={index > 0 ? "10px" : 0}
        >
          <Box
            bg="transparent"
            color="white"
            p="8px"
            borderRadius="32px"
            border="2px solid #374151"
            display="inline-block"
          >
            <Text minW="50px" color={highlight.color}>
              {" "}
              {highlight.word}{" "}
            </Text>
          </Box>
        </Flex>
      ))}
    </Flex>
  );
};

const BracketSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="30px" fill="white" viewBox="0 0 260 90" id="Flat">
    <path
      d="M35.89062,128C52.001,136.22559,52,155.64258,52,172c0,24.7998,1.35254,40,28,40a4,4,0,0,1,0,8c-36,0-36-26.61426-36-48,0-24.7998-1.35254-40-28-40a4,4,0,0,1,0-8c26.64746,0,28-15.2002,28-40,0-21.38574,0-48,36-48a4,4,0,0,1,0,8C53.35254,44,52,59.2002,52,84,52,100.35742,52.001,119.77441,35.89062,128Z"
      transform="rotate(270 50 50)"
    />
  </svg>
);

export default PromptExample;
